import styled from 'styled-components';

interface Point {
  x: number;
  y: number;
}

interface Props {
  startPoint: Point;
  endPoints: Point[];
  branchY: number;
  color?: string;
}

export function BranchingElbowConnectorVertical(props: Props) {
  const { startPoint, endPoints, branchY } = props;

  const circleRadius = 4;
  const lines = endPoints.map((endPoint, index) => {
    const circleMargin = 5;

    const sign = Math.sign(endPoint.y - startPoint.y);
    const cy = endPoint.y - (circleMargin + circleRadius) * sign;

    const linePoints = [
      {
        x: startPoint.x,
        y: startPoint.y,
      },
      {
        x: startPoint.x,
        y: branchY - circleRadius * sign,
      },
      {
        x: endPoint.x,
        y: branchY - circleRadius * sign,
      },
      {
        x: endPoint.x,
        y: cy - sign * circleRadius,
      },
    ];
    const pointString = linePoints.map(d => `${d.x},${d.y}`).join(' ');

    const color = props.color || '#b3b3b3';
    return (
      <g key={index}>
        <Line points={pointString} stroke={color} />
        <circle cx={endPoint.x} cy={cy} r={circleRadius} stroke={color} fill="transparent" />
      </g>
    );
  });

  return <G>{lines}</G>;
}

const G = styled.g`
  pointer-events: none;
`;

const Line = styled.polyline`
  fill: transparent;
  vector-effect: non-scaling-stroke;
`;
